{
  "A bench person counts 35 h/wk, a track alone 5 h; the bench prevails over the track.": "Barème : intercontrat 1 ETP soit 35 h/sem, track seule 5 h ; l'intercontrat l'emporte sur la track.",
  "AmpliFire": "AmpliFire",
  "An internal project counts once per person. The sponsor and the owner do not count.": "Un projet interne compte une fois par personne. Le sponsor et l'owner ne comptent pas.",
  "As in Boond": "Comme dans Boond",
  "Available on": "Disponible le",
  "Bench": "Intercontrat",
  "Check this table after each Boond change: a wrongly classified state skews every count. Out of scope: {{count}} active people (subcontractors, non-assignable, or set aside by the DAR).": "À relire après chaque évolution de Boond : un état mal classé fausse tous les comptes. Hors périmètre : {{count}} personnes actives (sous-traitants, non affectables, ou écartées par la DAR).",
  "Check this table after each Boond change: a wrongly classified state skews every count. Out of scope: {{count}} active people (subcontractors, non-assignable, or set aside by the DAR)._one": "À relire après chaque évolution de Boond : un état mal classé fausse tous les comptes. Hors périmètre : {{count}} personne active (sous-traitant, non affectable, ou écartée par la DAR).",
  "Check this table after each Boond change: a wrongly classified state skews every count. Out of scope: {{count}} active people (subcontractors, non-assignable, or set aside by the DAR)._other": "À relire après chaque évolution de Boond : un état mal classé fausse tous les comptes. Hors périmètre : {{count}} personnes actives (sous-traitants, non affectables, ou écartées par la DAR).",
  "Checks": "Contrôles",
  "Coach": "Coach",
  "Engine": "Engine",
  "Engine I&D": "Engine I&D",
  "Engine Officer": "Engine Officer",
  "Engine Officer in mission": "Engine Officer en mission",
  "Every Coach and AmpliFire has a project.": "Tous les Coachs et AmpliFire ont un projet.",
  "Every consultant in mission has an internal project.": "Tous les consultants en mission ont un projet interne.",
  "Every consultant in mission owes 5 h a week to I&D, on an internal project. These have none.": "Chaque consultant en mission chez un client doit 5 h par semaine à l'I&D, sur un projet interne. Ceux-ci n'en ont aucun.",
  "How Boond states are read": "Lecture des états Boond",
  "In mission": "En mission",
  "In scope": "Dans le périmètre",
  "Internal role": "Rôle interne",
  "Left": "Sorti",
  "Load": "Charge",
  "Loading the resources…": "Chargement des ressources…",
  "Long leave": "Absence longue durée",
  "Newcomers": "Nouveaux",
  "No newcomer.": "Aucun nouvel arrivant.",
  "No track": "Pas de track",
  "Nobody becomes available within two months.": "Personne ne se libère dans les deux mois.",
  "Nobody has an internal project yet.": "Personne n'a encore de projet interne.",
  "Nobody on the bench.": "Personne en intercontrat.",
  "Nobody. Every obligated person has an internal project.": "Personne. Tous les obligés ont un projet interne.",
  "Obligated without an internal project": "Obligés sans projet interne",
  "Onboarding": "Onboarding",
  "Out of scope": "Hors périmètre",
  "Out of scope (no capacity, no obligation)": "Hors périmètre (ni capacité, ni obligation)",
  "Outside the obligation: {{names}} (Coach or AmpliFire, volunteers).": "Hors obligation : {{names}} (Coach ou AmpliFire, volontaires).",
  "Person updated": "Personne mise à jour",
  "Qualify": "Qualifier",
  "Read as": "Lu comme",
  "Recruits in onboarding: neither bench nor obligation until Boond moves them.": "Recrues en onboarding : ni intercontrat, ni obligation tant que Boond ne les fait pas changer d'état.",
  "Resources": "Ressources",
  "Scope": "Périmètre",
  "Situation": "Situation",
  "Soon available": "Bientôt disponibles",
  "Staffed": "Staffé",
  "Staffed people whose Boond availability falls within two months. To anticipate for internal projects.": "Collaborateurs staffés dont la disponibilité Boond tombe dans les 2 mois. À anticiper pour les projets internes.",
  "The bench": "Banc",
  "What Boond does not know. Boond state: {{state}}.": "Ce que Boond ne sait pas. État Boond : {{state}}.",
  "Who carries what, the bench and the capacity, by Wanda's rules. Situations come from Boond, roles from ada.": "Qui porte quoi, le banc et la capacité, selon les règles de Wanda. Situations lues dans Boond, rôles tenus dans ada.",
  "Whole bench": "Tous les intercontrats",
  "Why obligated": "Obligation",
  "bench": "intercontrats",
  "bench + Engine Officers in mission": "intercontrats + Engine Officers en mission",
  "corrected": "corrigé",
  "in mission without project": "en mission sans projet",
  "obligations not met": "obligations non tenues",
  "perm. {{count}}": "perm. {{count}}",
  "real capacity": "capacité réelle",
  "res. {{count}}": "ress. {{count}}",
  "{{count}} without an internal project": "{{count}} sans projet interne",
  "{{fte}} FTE · {{count}} people": "{{fte}} ETP · {{count}} personnes",
  "{{fte}} FTE · {{count}} people_one": "{{fte}} ETP · {{count}} personne",
  "{{fte}} FTE · {{count}} people_other": "{{fte}} ETP · {{count}} personnes",
  "{{hours}} h/wk": "{{hours}} h/sem",
  "{{hours}} h/wk of I&D unallocated": "{{hours}} h/sem d'I&D non allouées"
}
